// extracted by mini-css-extract-plugin
export var content = "LegalContent-module--content--2UfWI";